import { merge as objectMerge } from '@tcc/shared/src/helpers/object';
import AbstractEventHandler from '../../csp/handlers/abstractEventHandler';
import { buildTrafficData } from '../../../utils/eventBusUtils';
import { sendPageEvent } from '../../../integrations/google/ga';
import { sendGenericConversion } from '../../../integrations/tealium/tealium';
import { createEventProperties, createTData } from '../eventProperties';
import { CONVERSION_SCHEMA_ID } from '../../../utils/schemaConstants';


class AddGenericConversion extends AbstractEventHandler {
  process() {
    super.process({
      TEALIUM: (input) => { this._handleTealium(input); },
      GA: (input) => { this._handleGA(input); },
      EVENT_SVC: (input) => { this._handleEventSvc(input); }
    });
  }

  _getEvents(input) {
    const properties = input.properties || {};

    return [{
      schemaId: CONVERSION_SCHEMA_ID,
      data: {
        virtualOrderId: properties.virtual_order_id,
        packageId: properties.package_id,
        packageCategory: properties.package_category,
        conversion: {
          area: input.area,
          revenue: input.revenue,
          product: input.product,
          action: input.action
        },
        traffic: buildTrafficData({ customProperties: input.custom_properties }),
        producerEventId: this.internal.eventId
      }
    }];
  }

  _handleGA(input) {
    sendPageEvent(
      input.eid,
      objectMerge(
        createTData(this.data).getProperties(),
        createEventProperties('genConv').getProperties(),
        input,
        this.internal),
      true);
  }

  _handleTealium(input) {
    sendGenericConversion(input);
  }

  _handleEventSvc(input) {
    const properties = objectMerge(input.properties, {
      // event service expects these to come through custom properties
      // and since we're reusing the addEvent interfacehere , there are
      // no first class fields for the below
      area: input.area,
      revenue: input.revenue,
      product: input.product,
      action: input.action
    });

    this.schemaHelper.handleSchema(
      'add_event',
      undefined,
      'v1',
      objectMerge(input, { type: 'genConv', properties }),
      this.internal,
      // This call should only go to the event service
      // The current handler will handle calls to GA/Tealium
      ['EVENT_SVC']);
  }
}

export default AddGenericConversion;
